export const ID_CONTENU = 'contenu'
export const ID_MENU = 'menu'
export const ID_CHAT = 'chat'

export const MODAL_ROOT_ID = 'modal-root'
export const PAGE_NAVIGATION_ROOT_ID = 'page-navigation-root'
export const PAGE_ACTIONS_ROOT_ID = 'page-actions-root'

export const MIN_DESKTOP_WIDTH = 600
